export default __webpack_public_path__ + "static/media/prototype-illustration.a715812d.png";